import { AxiosBase } from "./config/axiosBase.instance"

export const getProvinceAPI = () => {
   return AxiosBase.get("province")
}
